import { createAction, createAsyncThunk, createSlice, PrepareAction } from '@reduxjs/toolkit';
import { UserModel } from '@app/domain/UserModel';
import { persistUser, readUser } from '@app/services/localStorage.service';
import {
  getAllTransactions, createCategory, updateProduct, createProduct, getProductById, updateCategory, getAdminDashboardInfo, getAllClients, getAllCategories,
  getAllInternalUsers, getAllTestimonials,
  getClinicDashboardInfo, getInternalUserById, getOtherInfoById,
  getStatesTree, getTestimonialsById, saveFacility, saveTestimonials, SendInvitationEmails,
  updateExternalUserOtherInfo, updateFacility, updateInternalUser, updateOtherInfo, updateTestimonials,
  getCategoryById, getAllProducts, getAllOrders, getOrderById, getAllSubscriptions, getAllDeliveriesOfSubscription, getAllDeliveries,
  getAllRiders, getAllClientsOfDairy, updateRiderStatus, createInternalUser, updateInternalProfile, getGeoJSONData, createGeoJSONData,
  updateGeoJSONData, updateDeliveryStatus, getSingleVariant, createVariant, updateVariant, getAllVariant, deleteVariant, assignRider,
  getAllInvoices, getAddressesOfClient, createClientAddressStatus, updateClientDefaultAddress, updateClientAddress,
  deleteAddressOfClient,
  saveRecharges,
  getRecharges,
  orderSearch,
  initiateRefund,
  getSectorsData,
  deleteGeoJsonData,
  createPushNotification,
  updatePushNotification,
  getAllPushNotifications,
  getPushNotificationById,
  deletePushNotification,
  sendPushNotification,
  updateClientBalance,
  getAllPaymentLogs,
  getAllDeliverySlots,
  createDeliverySlot,
  updateDeliverySlot,
  deleteDeliverySlot,
  toggleDeliverySlot,
  getFirstRechargeConfig,
  updateFirstRechargeConfig,
  getCoupons,
  bulkGenerateCoupons,
  deleteCoupon,
  getGenericCoupons,
  createGenericCoupon,
  toggleGenericCoupon,
  getGenericRedemptions,
  getMetaAdsConfig,
  updateMetaAdsConfig,
  sendMetaAdsTestEvent,
  getAllSliders,
  createSlider,
  updateSlider,
  deleteSlider,
  toggleSliderStatus,
} from '@app/apis/user-api';

export interface UserState {
  user: UserModel | null;
  statesTree: any
}

const initialState: UserState = {
  user: readUser(),
  statesTree: []
};

export const setUser = createAction<PrepareAction<UserModel>>('user/setUser', (newUser) => {
  console.log({ newUser })
  persistUser(newUser);

  return {
    payload: newUser,
  };
});
export const setStatesTree = createAction<PrepareAction<any>>('user/setStatesTree', (data) => {
  console.log({ data })
  return {
    payload: data,
  };
});



export const getStatesTreeAction = createAsyncThunk('user/getStatesTreeAction', async (_, { dispatch }) =>
  getStatesTree().then(async (res: any) => {

    console.log({ res })
    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);

export const getGeoJSONDataAction = createAsyncThunk('user/getGeoJSONDataAction', async (_, { dispatch }) =>
  getGeoJSONData().then(async (res: any) => {

    console.log({ res })
    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);
export const getSectorsDataAction = createAsyncThunk('user/getSectorsDataAction', async (_, { dispatch }) =>
  getSectorsData().then(async (res: any) => {

    console.log({ res })
    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);
export const createGeoJSONAction = createAsyncThunk('user/createGeoJSONAction', async (type: any, { dispatch }) =>
  createGeoJSONData(type).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);

export const updateGeoJSONAction = createAsyncThunk('user/updateGeoJSONAction', async (type: any, { dispatch }) =>
  updateGeoJSONData(type).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);

export const deleteGeoJSONAction = createAsyncThunk('user/deleteGeoJSONAction', async (id: any, { dispatch }) =>
  deleteGeoJsonData(id).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);
export const getAllVariantAction = createAsyncThunk('user/getAllVariantAction', async (_id, { dispatch }) =>
  getAllVariant().then(async (res: any) => {

    console.log({ res })
    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);


export const getSingleVariantAction = createAsyncThunk('user/getSingleVariantAction', async (id: string, { dispatch }) =>
  getSingleVariant(id).then(async (res: any) => {

    console.log({ res })
    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);

export const createVariantActionn = createAsyncThunk('user/createGeoJSONAction', async (type: any, { dispatch }) =>
  createVariant(type).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);

export const updateVariantAction = createAsyncThunk('user/updateGeoJSONAction', async ({ id, payload }: { id: string, payload: any }, { dispatch }) =>
  updateVariant(id, payload).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);

export const deleteVariantAction = createAsyncThunk('user/deleteGeoJSONAction', async (id: string, { dispatch }) =>
  deleteVariant(id).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);






export const createCategoryAction = createAsyncThunk('user/createCategory', async (type: any, { dispatch }) =>
  createCategory(type).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);
export const createProductAction = createAsyncThunk('user/createProduct', async (type: any, { dispatch }) =>
  createProduct(type).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);

export const createInternalUserAction = createAsyncThunk('user/createInternalUserAction', async (type: any, { dispatch }) =>
  createInternalUser(type).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);

export const updateInternalUserAction = createAsyncThunk('user/updateInternalUser', async (type: any, { dispatch }) =>
  updateInternalUser(type).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);
export const updateInternalProfileAction = createAsyncThunk('user/updateInternalProfileAction', async (type: any, { dispatch }) =>
  updateInternalProfile(type).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);
export const getInternalUserByIdAction = createAsyncThunk('users/getInternalUserByIdAction', async (id: string, { dispatch }) =>
  getInternalUserById(id).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);

export const getAllInternalUsersAction = createAsyncThunk('users/getAllInternalUsersAction', async (params: any, { dispatch }) =>
  getAllInternalUsers(params).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);


export const updateCategoryAction = createAsyncThunk('user/updateCategory', async (type: any, { dispatch }) =>
  updateCategory(type).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);

export const updateExternalUserOtherInfoAction = createAsyncThunk('user/updateExternalUserOtherInfoAction', async (type: any, { dispatch }) =>
  updateExternalUserOtherInfo(type).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);




export const getAllCategoriesAction = createAsyncThunk('clinics/getALL', async (_, { dispatch }) =>
  getAllCategories().then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);


export const getAllProductsAction = createAsyncThunk('clinics/getALLProducts', async (params: any, { dispatch }) =>
  getAllProducts(params).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);

export const getAllTransactionsAction = createAsyncThunk('clinics/getAllTransactionsAction', async (params: any, { dispatch }) =>
  getAllTransactions(params).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);





export const getAllClientsAction = createAsyncThunk('clients/getALL', async (clinicId: number) =>
  getAllClients(clinicId).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);


export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setUser, (state, action) => {
      state.user = action.payload;
    });
    builder.addCase(getStatesTreeAction.fulfilled, (state, action) => {
      console.log('inside treeee case');
      state.statesTree = action.payload;
    });
  },
});


export const saveRechargesAction = createAsyncThunk('user/saveRechargesAction', async (type: any, { dispatch }) =>
  saveRecharges(type).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);



export const getRechargesAction = createAsyncThunk('user/getRechargesAction', async (type: any, { dispatch }) =>
  getRecharges(type).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);
/**
 * FACILITIES ACTIONS HERE
 */


export const createFacilityAction = createAsyncThunk('user/createFacilityAction', async (type: any, { dispatch }) =>
  saveFacility(type).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);

export const updateFacilityAction = createAsyncThunk('user/updateFacilityAction', async (payload: any, { dispatch }) =>
  updateFacility(payload).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);

export const getProductByIdAction = createAsyncThunk('users/getProductById', async (id: string, { dispatch }) =>
  getProductById(id).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);
export const getOrderByIdAction = createAsyncThunk('users/getOrderByIdAction', async (id: number, { dispatch }) =>
  getOrderById(id).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);

export const getAllOrdersAction = createAsyncThunk('users/getAllOrdersAction', async (params: any, { dispatch }) =>
  getAllOrders(params).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);
export const orderSearchAction = createAsyncThunk('users/orderSearchAction', async (id: any, { dispatch }) =>
  orderSearch(id).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);
export const getAllSubscriptionAction = createAsyncThunk('users/getAllSubscriptionAction', async (params: any, { dispatch }) =>
  getAllSubscriptions(params).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);
export const getAllRidersAction = createAsyncThunk('users/getAllRidersAction', async (params: any, { dispatch }) =>
  getAllRiders(params).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);


export const initiateRefundAction = createAsyncThunk('user/initiateRefundAction', async (args: any, { dispatch }) =>
  initiateRefund(args).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);


export const updateRiderStatusAction = createAsyncThunk('user/updateRiderStatusAction', async (payload: any, { dispatch }) =>
  updateRiderStatus(payload?.id, payload).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);

export const assignRiderAction = createAsyncThunk('user/assignRiderAction', async (payload: any, { dispatch }) =>
  assignRider(payload?.id, payload?.deliveryIds).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);


export const updateDeliveryStatusAction = createAsyncThunk('user/updateDeliveryStatusAction', async (payload: any, { dispatch }) =>
  updateDeliveryStatus(payload?.id, payload).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);

export const updateClientDefaultAddressAction = createAsyncThunk('user/updateClientDefaultAddressAction', async ({ clientId, addressId }: { clientId: string; addressId: string }, { dispatch }) =>
  updateClientDefaultAddress(clientId, addressId).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);



export const updateClientAddressAction = createAsyncThunk('user/updateClientAddressAction', async ({ id, payload }: { id: string; payload: any }, { dispatch }) =>
  updateClientAddress(id, payload).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);


export const createClientAddressAction = createAsyncThunk('user/createClientAddressAction', async (payload: any, { dispatch }) =>
  createClientAddressStatus(payload).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);


export const getAllClientsOfDairyAction = createAsyncThunk('users/getAllClientsOfDairyAction', async (params: any, { dispatch }) =>
  getAllClientsOfDairy(params).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);
export const deleteAddressOfClientAction = createAsyncThunk('users/deleteAddressOfClientAction', async (id: string, { dispatch }) =>
  deleteAddressOfClient(id).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);


export const getAddressesOfClientAction = createAsyncThunk('users/getAddressesOfClientAction', async (params: any, { dispatch }) =>
  getAddressesOfClient(params).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);


export const getAllDeliveriesOfSubscriptionAction = createAsyncThunk('users/getAllDeliveriesOfSubscriptionAction', async ({ id, params }: { id: string; params: any }, { dispatch }) =>
  getAllDeliveriesOfSubscription(id, params).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);
export const getAllDeliveriesAction = createAsyncThunk('users/getAllDeliveriesAction', async (params: any, { dispatch }) =>
  getAllDeliveries(params).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);
export const getAllInvoicesAction = createAsyncThunk('users/getAllInvoicesAction', async (params: any, { dispatch }) =>
  getAllInvoices(params).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);

export const getCategoryByIdAction = createAsyncThunk('users/getCategoryById', async (_id: string, { dispatch }) =>
  getCategoryById(_id).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);

// Push Notifications Actions
export const createPushNotificationAction = createAsyncThunk('user/createPushNotification', async (data: any, { dispatch }) =>
  createPushNotification(data).then(async (res: any) => {
    console.log({ res })
    return res;
  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;
  })
);

export const updatePushNotificationAction = createAsyncThunk('user/updatePushNotification', async (data: any, { dispatch }) =>
  updatePushNotification(data).then(async (res: any) => {
    console.log({ res })
    return res;
  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;
  })
);

export const getAllPushNotificationsAction = createAsyncThunk('pushNotifications/getAll', async (params: any = {}, { dispatch }) =>
  getAllPushNotifications(params).then(async (res: any) => {
    console.log({ res })
    return res;
  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;
  })
);

export const getPushNotificationByIdAction = createAsyncThunk('pushNotifications/getById', async (_id: string, { dispatch }) =>
  getPushNotificationById(_id).then(async (res: any) => {
    console.log({ res })
    return res;
  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;
  })
);

export const deletePushNotificationAction = createAsyncThunk('pushNotifications/delete', async (_id: string, { dispatch }) =>
  deletePushNotification(_id).then(async (res: any) => {
    console.log({ res })
    return res;
  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;
  })
);

export const sendPushNotificationAction = createAsyncThunk('pushNotifications/send', async (data: any, { dispatch }) =>
  sendPushNotification(data).then(async (res: any) => {
    console.log({ res })
    return res;
  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;
  })
);


export const updateProductAction = createAsyncThunk('users/updateProductAction', async (id: string, { dispatch }) =>
  updateProduct(id).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);



export const updateOtherInfoAction = createAsyncThunk('user/updateOtherInfoAction', async (payload: any, { dispatch }) =>
  updateOtherInfo(payload).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);


export const getOtherInfoByIdAction = createAsyncThunk('users/getOtherInfoByIdAction', async (id: number, { dispatch }) =>
  getOtherInfoById(id).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);





/**
 * TESTIMONIALS ACTIONS HERE
 */


export const createTestimonialAction = createAsyncThunk('user/createTestimonialAction', async (type: any, { dispatch }) =>
  saveTestimonials(type).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);

export const updateTestimonialAction = createAsyncThunk('user/updateTestimonialAction', async (payload: any, { dispatch }) =>
  updateTestimonials(payload).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);


export const getTestimonialByIdAction = createAsyncThunk('users/getTestimonialByIdAction', async (id: number, { dispatch }) =>
  getTestimonialsById(id).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);

export const getAllTestimonialAction = createAsyncThunk('users/getAllTestimonialAction', async (_, { dispatch }) =>
  getAllTestimonials().then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);




export const SendInvitationEmailsAction = createAsyncThunk('user/SendInvitationEmails', async (payload: any, { dispatch }) =>
  SendInvitationEmails(payload).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);


export const getAdminDashboardInfoAction = createAsyncThunk('users/adminDashboardInfo', async (_, { dispatch }) =>
  getAdminDashboardInfo().then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);

export const updateClientBalanceAction = createAsyncThunk('users/updateClientBalance', async ({ clientId, balance }: { clientId: string; balance: number }, { dispatch }) =>
  updateClientBalance(clientId, balance).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);




export const getAllPaymentLogsAction = createAsyncThunk('users/getAllPaymentLogsAction', async (params: any, { dispatch }) =>
  getAllPaymentLogs(params).then(async (res: any) => {

    console.log({ res })

    return res;

  }).catch((err) => {
    console.log({ err });
    if (err?.response?.data?.message) {
      throw err?.response?.data?.message
    }
    else throw err;

  })
);

// ─── Delivery Slot Actions ────────────────────────────────────────────────────

export const getAllDeliverySlotsAction = createAsyncThunk('deliverySlots/getAll', async (_, { dispatch }) =>
  getAllDeliverySlots().then(async (res: any) => {
    return res;
  }).catch((err) => {
    if (err?.response?.data?.message) throw err?.response?.data?.message;
    else throw err;
  })
);

export const createDeliverySlotAction = createAsyncThunk('deliverySlots/create', async (payload: any, { dispatch }) =>
  createDeliverySlot(payload).then(async (res: any) => {
    return res;
  }).catch((err) => {
    if (err?.response?.data?.message) throw err?.response?.data?.message;
    else throw err;
  })
);

export const updateDeliverySlotAction = createAsyncThunk('deliverySlots/update', async ({ id, payload }: { id: string; payload: any }, { dispatch }) =>
  updateDeliverySlot(id, payload).then(async (res: any) => {
    return res;
  }).catch((err) => {
    if (err?.response?.data?.message) throw err?.response?.data?.message;
    else throw err;
  })
);

export const deleteDeliverySlotAction = createAsyncThunk('deliverySlots/delete', async (id: string, { dispatch }) =>
  deleteDeliverySlot(id).then(async (res: any) => {
    return res;
  }).catch((err) => {
    if (err?.response?.data?.message) throw err?.response?.data?.message;
    else throw err;
  })
);

export const toggleDeliverySlotAction = createAsyncThunk('deliverySlots/toggle', async (id: string, { dispatch }) =>
  toggleDeliverySlot(id).then(async (res: any) => {
    return res;
  }).catch((err) => {
    if (err?.response?.data?.message) throw err?.response?.data?.message;
    else throw err;
  })
);

export const getFirstRechargeConfigAction = createAsyncThunk('coupons/getConfig', async (_, { dispatch }) =>
  getFirstRechargeConfig().then(async (res: any) => {
    return res;
  }).catch((err) => {
    if (err?.response?.data?.message) throw err?.response?.data?.message;
    else throw err;
  })
);

export const updateFirstRechargeConfigAction = createAsyncThunk('coupons/updateConfig', async (payload: any, { dispatch }) =>
  updateFirstRechargeConfig(payload).then(async (res: any) => {
    return res;
  }).catch((err) => {
    if (err?.response?.data?.message) throw err?.response?.data?.message;
    else throw err;
  })
);

export const getCouponsAction = createAsyncThunk('coupons/getCoupons', async (params: any, { dispatch }) =>
  getCoupons(params).then(async (res: any) => {
    return res;
  }).catch((err) => {
    if (err?.response?.data?.message) throw err?.response?.data?.message;
    else throw err;
  })
);

export const bulkGenerateCouponsAction = createAsyncThunk('coupons/bulkGenerate', async (payload: any, { dispatch }) =>
  bulkGenerateCoupons(payload).then(async (res: any) => {
    return res;
  }).catch((err) => {
    if (err?.response?.data?.message) throw err?.response?.data?.message;
    else throw err;
  })
);

export const deleteCouponAction = createAsyncThunk('coupons/deleteCoupon', async (id: string, { dispatch }) =>
  deleteCoupon(id).then(async (res: any) => {
    return res;
  }).catch((err) => {
    if (err?.response?.data?.message) throw err?.response?.data?.message;
    else throw err;
  })
);

export const getGenericCouponsAction = createAsyncThunk('coupons/getGeneric', async (_, { dispatch }) =>
  getGenericCoupons().then(async (res: any) => {
    return res;
  }).catch((err) => {
    if (err?.response?.data?.message) throw err?.response?.data?.message;
    else throw err;
  })
);

export const createGenericCouponAction = createAsyncThunk('coupons/createGeneric', async (payload: any, { dispatch }) =>
  createGenericCoupon(payload).then(async (res: any) => {
    return res;
  }).catch((err) => {
    if (err?.response?.data?.message) throw err?.response?.data?.message;
    else throw err;
  })
);

export const toggleGenericCouponAction = createAsyncThunk('coupons/toggleGeneric', async (payload: { id: string; is_active: boolean }, { dispatch }) =>
  toggleGenericCoupon(payload.id, payload.is_active).then(async (res: any) => {
    return res;
  }).catch((err) => {
    if (err?.response?.data?.message) throw err?.response?.data?.message;
    else throw err;
  })
);

export const getGenericRedemptionsAction = createAsyncThunk('coupons/genericRedemptions', async (id: string, { dispatch }) =>
  getGenericRedemptions(id).then(async (res: any) => {
    return res;
  }).catch((err) => {
    if (err?.response?.data?.message) throw err?.response?.data?.message;
    else throw err;
  })
);

export const getMetaAdsConfigAction = createAsyncThunk('metaAds/getConfig', async (_, { dispatch }) =>
  getMetaAdsConfig().then(async (res: any) => {
    return res;
  }).catch((err) => {
    if (err?.response?.data?.message) throw err?.response?.data?.message;
    else throw err;
  })
);

export const updateMetaAdsConfigAction = createAsyncThunk('metaAds/updateConfig', async (payload: any, { dispatch }) =>
  updateMetaAdsConfig(payload).then(async (res: any) => {
    return res;
  }).catch((err) => {
    if (err?.response?.data?.message) throw err?.response?.data?.message;
    else throw err;
  })
);

export const sendMetaAdsTestEventAction = createAsyncThunk('metaAds/sendTestEvent', async (payload: any, { dispatch }) =>
  sendMetaAdsTestEvent(payload).then(async (res: any) => {
    return res;
  }).catch((err) => {
    if (err?.response?.data?.message) throw err?.response?.data?.message;
    else throw err;
  })
);

// ─── Sliders / Banners Actions ────────────────────────────────────────────────
export const getAllSlidersAction = createAsyncThunk('sliders/getAll', async (params: any, { dispatch }) =>
  getAllSliders(params).then(async (res: any) => {
    return res;
  }).catch((err) => {
    if (err?.response?.data?.message) throw err?.response?.data?.message;
    else throw err;
  })
);

export const createSliderAction = createAsyncThunk('sliders/create', async (payload: any, { dispatch }) =>
  createSlider(payload).then(async (res: any) => {
    return res;
  }).catch((err) => {
    if (err?.response?.data?.message) throw err?.response?.data?.message;
    else throw err;
  })
);

export const updateSliderAction = createAsyncThunk('sliders/update', async ({ id, payload }: { id: string; payload: any }, { dispatch }) =>
  updateSlider(id, payload).then(async (res: any) => {
    return res;
  }).catch((err) => {
    if (err?.response?.data?.message) throw err?.response?.data?.message;
    else throw err;
  })
);

export const deleteSliderAction = createAsyncThunk('sliders/delete', async (id: string, { dispatch }) =>
  deleteSlider(id).then(async (res: any) => {
    return res;
  }).catch((err) => {
    if (err?.response?.data?.message) throw err?.response?.data?.message;
    else throw err;
  })
);

export const toggleSliderStatusAction = createAsyncThunk('sliders/toggleStatus', async (id: string, { dispatch }) =>
  toggleSliderStatus(id).then(async (res: any) => {
    return res;
  }).catch((err) => {
    if (err?.response?.data?.message) throw err?.response?.data?.message;
    else throw err;
  })
);

export default userSlice.reducer;



